import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/loading-spinner.png'


const _withScopeId = n => (_pushScopeId("data-v-73458323"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-spinner-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "spinner",
    src: _imports_0,
    alt: "loading-icon"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}